const axisSteps = [1, 1.5, 2, 2.5, 5];
const approximateLabelsCount = 5;

export function getAxisValues(maxValue: number, minValue: number = 0): number[] {
    let labelsCount = approximateLabelsCount;
    let stepIndex = 0;
    let stepMultiplier = 1;
    const bottomShift = Math.max(0, minValue - (minValue % 5) - 5);
    const topValue = maxValue - bottomShift;

    while (axisSteps[stepIndex] * stepMultiplier * (labelsCount - 1) <= topValue) {
        if (stepIndex === axisSteps.length - 1) {
            stepIndex = 0;
            stepMultiplier *= 10;
        } else {
            stepIndex += 1;
        }
    }

    const result =  Array(labelsCount)
        .fill(0)
        .map((_, index) => axisSteps[stepIndex] * stepMultiplier * index + bottomShift);

    while (maxValue < result[result.length - 2] && result.length > 2) {
        result.pop();
    }

    while (result[1] < minValue && result.length > 2) {
        result.shift();
    }

    return result.reverse();
}

export function getAxisLabelString(value: number): string {
    if (value >= 10 ** 9) {
        return `${(value / 10 ** 9)}B`;
    }
    else if (value >= 10 ** 6) {
        return `${value / 10 ** 6}M`;
    }
    else if (value >= 10 ** 3) {
        return `${value / 10 ** 3}K`;
    }
    else {
        return `${value}`;
    }
}